/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
export const SubscriptionSortProperty = {
    Customer: "customer",
    MinusCustomer: "-customer",
    Status: "status",
    MinusStatus: "-status",
    StartedAt: "started_at",
    MinusStartedAt: "-started_at",
    CurrentPeriodEnd: "current_period_end",
    MinusCurrentPeriodEnd: "-current_period_end",
    Amount: "amount",
    MinusAmount: "-amount",
    Product: "product",
    MinusProduct: "-product",
    Discount: "discount",
    MinusDiscount: "-discount",
};
/** @internal */
export const SubscriptionSortProperty$inboundSchema = z.nativeEnum(SubscriptionSortProperty);
/** @internal */
export const SubscriptionSortProperty$outboundSchema = SubscriptionSortProperty$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var SubscriptionSortProperty$;
(function (SubscriptionSortProperty$) {
    /** @deprecated use `SubscriptionSortProperty$inboundSchema` instead. */
    SubscriptionSortProperty$.inboundSchema = SubscriptionSortProperty$inboundSchema;
    /** @deprecated use `SubscriptionSortProperty$outboundSchema` instead. */
    SubscriptionSortProperty$.outboundSchema = SubscriptionSortProperty$outboundSchema;
})(SubscriptionSortProperty$ || (SubscriptionSortProperty$ = {}));
//# sourceMappingURL=subscriptionsortproperty.js.map